export const ReportTransfer = Object.freeze({
    NOT_IS_TRANSFER: 'Somente Romaneios',
    TRANSFERS_ONLY: 'Somente Transferências',
    ALL: 'Completo'
});